import type { Feature } from 'api';
import { Stack } from 'ui';

import { formatDirtScore } from '../../utils/formatDirtScore/formatDirtScore';
import { formatPercentageFeature } from '../../utils/formatFeature/formatFeature';
import {
  getClearPercentage,
  getNonPetBottlePercentage,
  getPetBottlePercentage,
} from '../../utils/materialPercentages/materialPercentages';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';

export const PetMaterialBreakdown = ({ features }: { features: Record<string, Feature | number> }) => {
  const petBottle = getPetBottlePercentage(features);
  const clear = getClearPercentage(features);
  const nonPetBottle = getNonPetBottlePercentage(features);

  return (
    <Stack gap={2} data-testid="pet-material-breakdown">
      <div>
        <MaterialBreakdownItem label="PET Bottle" value={formatPercentageFeature(petBottle)} variant="bold" />
        <MaterialBreakdownItem label="Clear" value={formatPercentageFeature(clear)} />
        <MaterialBreakdownItem
          label="Light Blue"
          value={formatPercentageFeature(features['features_material_Light blue'])}
        />
        <MaterialBreakdownItem
          label="Dark Blue"
          value={formatPercentageFeature(features['features_material_Dark blue'])}
        />
        <MaterialBreakdownItem label="Green" value={formatPercentageFeature(features.features_material_Green)} />
        <MaterialBreakdownItem
          label="Other"
          value={formatPercentageFeature(features['features_material_Other colour'])}
        />
        <MaterialBreakdownItem
          label="Clear, non-food-grade"
          value={formatPercentageFeature(features['features_material_Clear Non-Food grade'])}
          variant="standard"
        />
      </div>

      <div>
        <MaterialBreakdownItem label="Non-PET Bottle" value={formatPercentageFeature(nonPetBottle)} variant="bold" />
        <MaterialBreakdownItem
          label="Clear PET Tray"
          value={formatPercentageFeature(features['features_material_Clear tray'])}
        />
        <MaterialBreakdownItem label="Film" value={formatPercentageFeature(features.features_material_Film)} />
        <MaterialBreakdownItem
          label="Other Plastic"
          value={formatPercentageFeature(features['features_material_Other Plastic'])}
        />
        <MaterialBreakdownItem
          label="Non-Plastic"
          value={formatPercentageFeature(features['features_material_Non Plastic'])}
        />
      </div>

      <MaterialBreakdownItem
        variant="bold"
        label="Cleanliness"
        tooltipContent="Cleanliness is a measure of how clean the material is. This ranges from very clean, clean, average, dirty and very dirty. Dirt includes grease, spots and dust present on the surface of the material."
        value={formatDirtScore(features.features_dirt_mean)}
      />
    </Stack>
  );
};
